var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "add_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "add_svg__add"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1",
    className: "add_svg__vector"
  }))));
};
export { SvgAdd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BZGQ8L3RpdGxlPjxnIGNsYXNzPSJhZGQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE4IDEzaC01djVjMCAuNTUtLjQ1IDEtMSAxcy0xLS40NS0xLTF2LTVINmMtLjU1IDAtMS0uNDUtMS0xcy40NS0xIDEtMWg1VjZjMC0uNTUuNDUtMSAxLTFzMSAuNDUgMSAxdjVoNWMuNTUgMCAxIC40NSAxIDFzLS40NSAxLTEgMVoiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";